// ファイル名: assets/product-accordion.js
// 商品メタフィールド連携アコーディオン - 最終版（軽量版）
// ES6準拠、jQuery非依存

class ProductAccordionEnhanced {
  constructor() {
    this.accordions = document.querySelectorAll('.product-accordion-enhanced');
    this.init();
  }

  init() {
    if (this.accordions.length === 0) return;
    
    this.setupAccordions();
    this.setupKeyboardNavigation();
  }

  setupAccordions() {
    this.accordions.forEach((accordion, index) => {
      const details = accordion.querySelector('.accordion-details');
      const summary = accordion.querySelector('.accordion-summary');
      const content = accordion.querySelector('.accordion__content');
      
      if (!details || !summary || !content) return;

      // ARIA属性の設定
      this.setupAriaAttributes(details, summary, content);
      
      // イベントリスナーの追加
      summary.addEventListener('click', (e) => this.handleToggle(e, details, summary, content));
      summary.addEventListener('keydown', (e) => this.handleKeyboard(e));
    });
  }

  setupAriaAttributes(details, summary, content) {
    const isOpen = details.hasAttribute('open');
    
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', isOpen.toString());
    summary.setAttribute('aria-controls', content.id);
    summary.setAttribute('tabindex', '0');
    
    content.setAttribute('role', 'region');
    content.setAttribute('aria-labelledby', details.id);
    
    if (!isOpen) {
      content.setAttribute('aria-hidden', 'true');
    }
  }

  handleToggle(event, details, summary, content) {
    event.preventDefault();
    
    const isOpen = details.hasAttribute('open');
    
    // ARIA属性の更新
    summary.setAttribute('aria-expanded', (!isOpen).toString());
    content.setAttribute('aria-hidden', isOpen.toString());
    
    // アコーディオンの開閉
    if (isOpen) {
      details.removeAttribute('open');
    } else {
      details.setAttribute('open', '');
    }
    
    // カスタムイベントの発火
    this.dispatchCustomEvent(details.closest('.product-accordion-enhanced'), 
                            !isOpen ? 'accordion:open' : 'accordion:close');
  }

  handleKeyboard(event) {
    const { key, target } = event;
    
    switch (key) {
      case 'Enter':
      case ' ':
        // スペースキーとエンターキーでトグル
        event.preventDefault();
        target.click();
        break;
        
      case 'Escape':
        // エスケープキーで閉じる
        const details = target.closest('.accordion-details');
        if (details && details.hasAttribute('open')) {
          target.click();
        }
        break;
        
      case 'ArrowDown':
      case 'ArrowUp':
        // 矢印キーで他のアコーディオンに移動
        event.preventDefault();
        this.navigateAccordions(target, key === 'ArrowDown');
        break;
    }
  }

  setupKeyboardNavigation() {
    // フォーカス管理
    this.accordions.forEach(accordion => {
      const summary = accordion.querySelector('.accordion-summary');
      if (summary) {
        summary.addEventListener('focus', () => {
          accordion.classList.add('accordion-focused');
        });
        
        summary.addEventListener('blur', () => {
          accordion.classList.remove('accordion-focused');
        });
      }
    });
  }

  navigateAccordions(currentSummary, goDown) {
    const allSummaries = Array.from(document.querySelectorAll('.product-accordion-enhanced .accordion-summary'));
    const currentIndex = allSummaries.indexOf(currentSummary);
    
    if (currentIndex === -1) return;
    
    let nextIndex;
    if (goDown) {
      nextIndex = currentIndex + 1;
      if (nextIndex >= allSummaries.length) nextIndex = 0;
    } else {
      nextIndex = currentIndex - 1;
      if (nextIndex < 0) nextIndex = allSummaries.length - 1;
    }
    
    allSummaries[nextIndex].focus();
  }

  dispatchCustomEvent(element, eventName, detail = {}) {
    const event = new CustomEvent(eventName, {
      detail: {
        accordion: element,
        ...detail
      },
      bubbles: true,
      cancelable: true
    });
    
    element.dispatchEvent(event);
  }

  // 外部からアコーディオンを制御するメソッド
  openAccordion(accordionId) {
    const details = document.querySelector(`[data-accordion-id="${accordionId}"]`);
    if (details && !details.hasAttribute('open')) {
      const summary = details.querySelector('.accordion-summary');
      if (summary) summary.click();
    }
  }

  closeAccordion(accordionId) {
    const details = document.querySelector(`[data-accordion-id="${accordionId}"]`);
    if (details && details.hasAttribute('open')) {
      const summary = details.querySelector('.accordion-summary');
      if (summary) summary.click();
    }
  }

  openAll() {
    this.accordions.forEach(accordion => {
      const details = accordion.querySelector('.accordion-details');
      if (details && !details.hasAttribute('open')) {
        const summary = details.querySelector('.accordion-summary');
        if (summary) summary.click();
      }
    });
  }

  closeAll() {
    this.accordions.forEach(accordion => {
      const details = accordion.querySelector('.accordion-details');
      if (details && details.hasAttribute('open')) {
        const summary = details.querySelector('.accordion-summary');
        if (summary) summary.click();
      }
    });
  }

  destroy() {
    // イベントリスナーの削除は自動的に行われるため、特別な処理は不要
    this.accordions = null;
  }
}

// 初期化とグローバル登録
document.addEventListener('DOMContentLoaded', () => {
  // インスタンス作成
  window.productAccordionEnhanced = new ProductAccordionEnhanced();
});

// Shopifyのセクション再読み込み対応
document.addEventListener('shopify:section:load', () => {
  if (window.productAccordionEnhanced) {
    window.productAccordionEnhanced.destroy();
  }
  // 少し遅延させて新しいDOM要素を確実に取得
  setTimeout(() => {
    window.productAccordionEnhanced = new ProductAccordionEnhanced();
  }, 100);
});

// Shopifyのセクション削除対応
document.addEventListener('shopify:section:unload', () => {
  if (window.productAccordionEnhanced) {
    window.productAccordionEnhanced.destroy();
  }
});